import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200 pt-14 md:pt-16 pb-8">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading font-bold text-sm">
                古
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                古古漫画网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {footerData.description}
            </p>
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center bg-background-800 text-background-300 rounded-lg text-sm hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center bg-background-800 text-background-300 rounded-lg text-sm hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center bg-background-800 text-background-300 rounded-lg text-sm hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-background-50 mb-4 text-sm">快速导航</h3>
            <div className="grid grid-cols-2 gap-2">
              {footerData.links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick(link.href);
                  }}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-background-50 mb-4 text-sm">合作伙伴</h3>
            <p className="text-sm text-background-500">虚位以待，诚邀优质漫画平台与内容创作者加入合作。</p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">{footerData.copyright}</p>
          <p className="text-xs text-background-600">{footerData.icp}</p>
        </div>
      </div>
    </footer>
  );
}